import type { CustomFile } from '../../types';

import type { TypeUploadFeature } from './types';

// ----------------------------------------------------------------------------

/*
 * Asks every feature whether this file is worth sending. Any single no is enough, and the rest are
 * not consulted — a feature that turns a file down has already spent whatever it needed to decide.
 *
 * With no feature registering `fnShouldSend` this is always true, which is what keeps the engine
 * correct when every block is off.
 */
async function shouldSend(plugins: TypeUploadFeature[], file: CustomFile): Promise<boolean> {
    for (const plugin of plugins) {
        if (plugin.fnShouldSend && !(await plugin.fnShouldSend(file))) {
            return false;
        }
    }

    return true;
}

// ----------------------------------------------------------------------------

export default shouldSend;
